export default {
  // 页面标题
  titles: {
    campaignList: 'Campaign list',
  },
  
  // 按钮
  buttons: {
    createCampaign: 'Create a campaign',
  },
  
  // 状态
  status: {
    creating: 'Creating...',
    loading: 'Loading...',
  },
  
  // 消息
  messages: {
    deleteSuccess: 'Campaign deleted successfully',
    deleteFailed: 'Failed to delete campaign',
    bindOrgSuccess: 'Organization bound successfully',
    bindOrgFailed: 'Failed to bind organization',
  },
  
  // 错误消息
  errors: {
    getCampaignListFailed: 'Failed to get campaign list',
    createCampaignFailed: 'Failed to create campaign',
  },

  // 空状态
  empty: {
    noCampaigns: 'You haven\'t set up any campaigns yet. Set up your campaigns now to start achieving results!',
  },
};
